<div class="pt-4">
  <label class="block font-accent font-bold mt-5 mb-3 md:mt-6 text-md"
    >{{ title }}
    @if (required) {
      <span>&#42;</span>
    }
  </label>
  <app-input-multi-atom
    [type]="'text'"
    [placeholder]="placeholder"
    [value]="value"
    [inputMode]="inputCharset === 'numeric' ? 'numeric' : ''"
    [digitsOnly]="inputCharset === 'numeric'"
    (valueEmitter)="onValueChange($event)"
  ></app-input-multi-atom>
</div>
